<template>
  <div class="m-0 dbozone-font bg-romaKingdom" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="game-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.name') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.paytable') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.paytable-des') }}</h5>
      </div>


      <div class="grid-container">
        <div v-for="(symbol, index) in symbols" :key="index" class="grid-item">
          <img v-if="index < 9" :src="symbol.image" class="symbol-image" alt="symbol" />
          <div v-if="index < 9" class="payouts">
            <div v-for="(key) in Object.keys(symbol.payouts).map(Number).sort((a, b) => b - a)" :key="key"
              class="payout-row">
              <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">{{ key
              }}&nbsp;&nbsp;|</span>
              <span class="sub-text-payout">{{ symbol.payouts[key] }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.wild-symbol') }}</h5>
      </div>

      <div class="symbol-container">
        <div>
          <div class="symbol-content">
            <img :src="require(`../../assets/ruleGames/romaKingdom/wild.png`)" alt="wild-symbol"
              class="special-symbol-image" />
            <span>
              <ul v-for="(li, index) in 1" :key="index" class="symbol-info">
                <li class="sub-text-list-gray">{{ $t(`romaKingdom.wild-info${index + 1}`) }}</li>
              </ul>
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-symbol') }}</h5>
      </div>

      <div class="symbol-container">
        <div>
          <div class="symbol-content">
            <img :src="require(`../../assets/ruleGames/romaKingdom/bonus.png`)" alt="bonus-symbol"
              class="special-symbol-image" />
            <span>
              <ul class="symbol-info">
                <li class="sub-text-list-gray"> {{ $t('romaKingdom.bonus-info') }}</li>
              </ul>
            </span>
          </div>
          <div class="pt-5">
            <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-des1') }}</h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-des2') }}</h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-des3') }}</h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-des4') }}</h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-des5') }}</h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.bonus-des6') }}</h5>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.freespin') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/romaKingdom/freespin_feature.png`)" alt="freespin-feature"
          class="freespin-feature-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <div class="p-4">
          <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t(`romaKingdom.freespin-des1`) }}</h5>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t(`romaKingdom.freespin-des2`) }}</h5>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/romaKingdom/feature_buy_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul v-for="(li, index) in 7" :key="index" class="symbol-info">
            <li v-if="index !== 3 && index !== 4 && index !== 5" class="sub-text-list-gray">
              {{ $t(`romaKingdom.featurebuy-des${index + 1}`) }}
            </li>
            <li v-else-if="index === 3" class="sub-text-list-gray">
              {{ $t(`romaKingdom.featurebuy-des${index + 1}`) }}
              {{ currencyFormatterWithSymbol(betMinMax[0]) }}
              {{ $t(`romaKingdom.featurebuy-des${index + 1}-1`) }}
              {{ currencyFormatterWithSymbol(featureBuyMaximum) }}
            </li>
            <li v-else-if="index === 4" class="sub-text-list-gray">
              {{ $t(`romaKingdom.featurebuy-des${index + 1}`) }}
              {{ `x${featureBuyMultiplier}` }}
              {{ $t(`romaKingdom.featurebuy-des${index + 1}-1`) }}
            </li>
            <li v-else-if="index === 5" class="sub-text-list-gray">
              {{ $t(`romaKingdom.featurebuy-des${index + 1}`) }}
              {{ currencyFormatterWithSymbol(featureBuyMaximum) }}
            </li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.mode-featurebuy') }}</h5>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/romaKingdom/feature_buy_freespin_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>
      <div class="p-4">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t(`romaKingdom.mode-featurebuy-des1`) }}
        </h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/romaKingdom/feature_buy_bonus_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>
      <div class="p-4">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t(`romaKingdom.mode-featurebuy-des2`) }}
        </h5>
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t(`romaKingdom.mode-featurebuy-des3`) }}
        </h5>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title adjustment-text" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.adjustment') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.adjustment-des') }}
          </h5>
          <div>
            <span class="m-0 sub-text ">{{ $t('romaKingdom.note') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('romaKingdom.note-des1') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('romaKingdom.note-des2') }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span class="justify-content-center align-items-center">
          <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.win-line') }}</h5>
          <!-- <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.win-line-des') }}</h5> -->
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/romaKingdom/win_line.png`)" alt="win-line" class="win-line-image" />
      </div>

      <div class="p-4">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.ways-des1') }}</h5>
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.ways-des2') }}</h5>
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.ways-des3') }}</h5>
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.ways-des4') }}</h5>
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.ways-des5') }}</h5>
      </div>

      <div class="d-flex pt-5 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.gamerule') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.win-line-des') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/romaKingdom/slotmachine.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <li class="sub-text-gray" :class="`-${lang} -romaKingdom`">
            {{ $t('romaKingdom.min-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</li>
          <li class="sub-text-gray" :class="`-${lang} -romaKingdom`">
            {{ $t('romaKingdom.max-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -romaKingdom`">
            {{ $t('romaKingdom.game-rule1-1') }}
            {{ baseBet }}
            {{ $t('romaKingdom.game-rule1-2') }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -romaKingdom`">
            {{ $t('romaKingdom.game-rule2-1') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}
            {{ $t('romaKingdom.to') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
            {{ $t('romaKingdom.game-rule2-2') }}</li>
          <li class="sub-text-gray" :class="`-${lang} -romaKingdom`">
            {{ $t('romaKingdom.game-rule3') }}
            {{ currency + `(` + formattedCurrency + `)` }}
          </li>
          <li v-for="(li, index) in 5" :key="index" class="sub-text-gray" :class="`-${lang} -romaKingdom`">
            {{ $t(`romaKingdom.game-rule${index + 4}`) }}
          </li>
        </span>
      </div>

      <div class="d-flex pt-2 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.round') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -romaKingdom`">{{ $t('romaKingdom.round-des') }}</h5>
          <span v-for="(li, index) in 8" :key="index">
            <div
              v-if="index + 1 === 1 || index + 1 === 2 || index + 1 === 3 || index + 1 === 4 || index + 1 === 5 || index + 1 === 6">
              <span class="pb-2 [t-2 sub-text" :class="`-${lang} -romaKingdom`">
                {{ $t(`romaKingdom.round-title${index + 1}`) }}
                <span class="sub-text-gray" :class="`-${lang} -romaKingdom`">{{ $t(`romaKingdom.round-des${index + 1}`)
                  }}</span>
                <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -romaKingdom`">{{
                  $t(`romaKingdom.round-des${index + 2}`) }}</li>
                <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -romaKingdom`">{{
                  $t(`romaKingdom.round-des${index + 3}`) }}</li>
              </span>
            </div>
          </span>
        </span>

      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -romaKingdom`">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/spin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 4" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/autospin_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/stop_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/betsize_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/info_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/additional_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/setting_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/history_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/home_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/icon_wallet.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/icon_refresh.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/romaKingdom/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{ $t(`main-game.winnings-button-des${index
              + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des1') }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des2') }}
          </li>
        </u>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-romaKingdom',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    featureBuyMultiplier: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: [],
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 1; i < 9; i++) {
        const id = (9 - i) - 1;
        symbolsData.push({
          id: id,
          image: require(`../../assets/resultGame/romaKingdom/1/symbol_${id}.png`),
          payouts: {
            3: this.decimalFormat(this.currentBet * this.data.config.payTable[id][2] / this.baseBet),
            4: this.decimalFormat(this.currentBet * this.data.config.payTable[id][3] / this.baseBet),
            5: this.decimalFormat(this.currentBet * this.data.config.payTable[id][4] / this.baseBet),
            // 6: this.decimalFormat(this.currentBet * this.data.config.payTable[id][5] / this.baseBet)
          }
        });
      }
      this.symbols = symbolsData;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.currentBet * this.data.config.payTable[id][5] / this.baseBet).length;
      let magin = 'calc(29%)'

      if (maxLength < 5) {
        magin = 'calc(29%)'
      } else if (maxLength === 5) {
        magin = 'calc(23%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = 'calc(19%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = 'calc(16%)'
      } else if (maxLength >= 9 && maxLength < 11) {
        magin = 'calc(10%)'
      } else {
        magin = 'calc(5%)'
      }

      return {
        marginLeft: magin,
      };
    },
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  padding: 40px;
  background-color: #202020;
  border-radius: 20px;
  margin: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: 60%;
  height: auto;
}

.payouts {
  margin-top: 10px;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: 25%;
  margin-right: 20px;
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 70%;
  height: auto;
}

.multiplier-image {
  width: 95%;
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 70%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 100%;
  height: auto;
}
</style>

<style>
.bg-romaKingdom {
  background: #282828;
}

.game-title {
  font-size: 3vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
  /* margin: 0 8px; */
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: 150px;
  height: 150px;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>